import React, { useContext, useEffect, useState } from 'react';
import { T } from '../../../traks';
import { ContentHeader } from '../DashboardPage';
import { APIPost, APIGet } from '../../../API';
import MeContext from '../../../MeContext';
import { Input, PhoneInp } from '../../../c/Input';
import { passwordValidator, rePasswordValidator, PasswordErrorText, RePasswordErrorText } from '../../../c/Input/InputValidators';
import { Loading } from '../../../c/Loading';
import { AlertModal } from '../../../c/Modals';
import DashboardContext from '../../../contexts/dashboardContext';

const MyAccount = ({ user, setUser, ...props }) => {
    const { me } = useContext(MeContext)
    const { updateData, setUpdateData } = useContext(DashboardContext)
    const { company_id } = me
    const userId = me.user_id
    const [myAccountSettings, setMyAccountSettings] = useState({})
    const [showRequiredWarnings, setShowRequiredWarnings] = useState(false)
    const [alertType, setAlertType] = useState({ type: "", text: "" })
    const [showAlert, setShowAlert] = useState(false)
    const [showLoading, setShowLoading] = useState(false)

    const [verifyCred, setVerifyCred] = useState({
        email2: '',
        password2: '',
    });


    const saveSettings = () => {
        setShowRequiredWarnings(false)
        const resource = "users/" + userId
        setShowLoading(true)
        APIPost(resource, { user_settings: { ...myAccountSettings }, company_id: company_id }).then(res => {
            setAlertType({ type: "success", text: "settings updated" })
            setShowAlert(true)
            setMyAccountSettings({})
            setVerifyCred({ email2: "", password2: "" })
            getUser()
        }).catch(err => {
            setShowLoading(false)
            setAlertType({ type: "error", text: err.response.data })
            setShowAlert(true)
            console.log(err)
        })
    }

    const getUser = () => {
        setShowLoading(true)
        const resource = "users/" + userId
        APIGet(resource, { company_id: company_id }).then(res => {
            setShowLoading(false)
            const { username, email, screen_name, phone_number, name } = res.data.user
            setUser({ username, email, screen_name, phone_number, name })
        }).catch(err => {
            setShowLoading(false)
            setAlertType({ type: "error", text: err.response.data })
            setShowAlert(true)
            console.log(err)
        })
    }

    const formIsValid = () => {
        return !myAccountSettings["password"] || (passwordValidator(myAccountSettings["password"])
            && rePasswordValidator(verifyCred.password2, myAccountSettings["password"]))
    }

    const handleSignup = () => {
        console.log(formIsValid())
        if (!formIsValid()) {
            setShowRequiredWarnings(true)
        } else {
            saveSettings()
        }
    }


    useEffect(() => {
        getUser()
        setUpdateData(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [me, updateData])


    if (!user) {
        return (
            <Loading
                showLoading={showLoading}
                inFront
            />
        )
    }

    return (
        <>
            <ContentHeader>
                <T>Edit your details</T>
            </ContentHeader>
            <div className="row">
                <div className="col" style={{ maxWidth: "100rem" }}>
                    <div className="row">
                        <div className="col-md-6 col-xs-12">
                            <div className="fw_700 fs-5 mb-4"><T>User information</T></div>
                            <div>
                                <T>Here there supposed to be some meaningful text</T>
                                <br />
                                <T>about user stuff, the planet of xpiwtr and blueberry pie...</T>
                            </div>
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <form onSubmit={(e) => e.preventDefault()}>
                                <Input
                                    className="mt-4 w-100"
                                    type="name"
                                    id={"username"}
                                    disabled={true}
                                    onChange={null}
                                    dataCy="username"
                                    placeholder={<T>username</T>}
                                    initValue={(user && user.username) || ""}
                                />
                                <Input
                                    className="mt-4 w-100"
                                    type="name"
                                    dataCy="name"
                                    id={"name"}
                                    onChange={(name) => setMyAccountSettings({ ...myAccountSettings, name: name })}
                                    placeholder={<T>name</T>}
                                    initValue={(user && user.name) || ""}
                                />
                                <Input
                                    className="mt-4 w-100"
                                    type="name"
                                    dataCy="screenName"
                                    id={"screenName"}
                                    onChange={(screenName) => setMyAccountSettings({ ...myAccountSettings, screen_name: screenName })}
                                    placeholder={<T>screen name</T>}
                                    initValue={(user && user.screen_name) || ""}
                                />
                                <PhoneInp
                                    initValue={(user && user.phone_number) || ""}
                                    setPhoneNumber={(phone) => setMyAccountSettings({ ...myAccountSettings, phone_number: phone })}
                                    className="mt-5"
                                />
                                <Input
                                    className="mt-4 w-100"
                                    dataCy="email"
                                    id={"email"}
                                    initValue={(user && user.email) || ""}
                                    type="email"
                                    onChange={(email) => setMyAccountSettings({ ...myAccountSettings, email })}
                                    placeholder={<T>email</T>}

                                />
                                <div className="mt-5" >
                                    <Input
                                        rounded
                                        dataCy="password"
                                        id={"password"}
                                        autocomplete="off"
                                        type="password"
                                        placeholder={<T>Password</T>}
                                        onChange={(password) => setMyAccountSettings({ ...myAccountSettings, password })}
                                    />
                                    <PasswordErrorText value={myAccountSettings["password"]} showEmptyWarning={showRequiredWarnings} />
                                </div>
                                <div className="mt-5">
                                    <Input
                                        rounded
                                        dataCy="password-again"
                                        id={"passwordAgain"}
                                        autocomplete="off"
                                        type="password"
                                        placeholder={<T>Password again</T>}
                                        onChange={(password2) =>
                                            setVerifyCred({
                                                ...verifyCred,
                                                password2,
                                            })
                                        }
                                    />
                                    <RePasswordErrorText value={verifyCred.password2} refValue={myAccountSettings["password"]} showEmptyWarning={showRequiredWarnings} />
                                </div>
                                <div className="text-center mt-4">
                                    <button onClick={() => handleSignup()} id={"submitBtn"} type="submit" className="btn btn_green mt-3">
                                        <T>SUBMIT</T>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <Loading
                showLoading={showLoading}
                inFront
                overlay
            />
            <AlertModal
                isShowing={showAlert}
                setIsShowing={setShowAlert}
                type={alertType.type}
                text={alertType.text}
            />
        </>
    );
};

export default MyAccount;
